import { useQuoteStatusUtils } from '@axo/shared/data-access/hooks';
import { ace_index, loan_quote } from '@axo/shared/data-access/types';
import { StatusTag } from '../StatusTag';

interface Props {
  app: ace_index.LoanApplication;
}

export function QuoteStatuses({ app }: Props) {
  const statuses = useQuoteStatusUtils();

  if (app.LoanQuotes === undefined) {
    return null;
  }

  const all = app.LoanQuotes?.map((req) => req.StatusCode).filter(
    (status): status is number => !!status,
  );

  const unique = [...new Set(all)];

  const codes = unique
    .map(statuses.fromCode)
    .filter((code): code is loan_quote.LoanQuoteStatus => code !== undefined);

  return (
    <>
      {codes.map((code) => (
        <StatusTag key={code} status={code}>
          {code}
        </StatusTag>
      ))}
    </>
  );
}
